import WidgetDrawer from 'components/WidgetDrawer';
import * as React from 'react';
import WidgetRelations from 'views/Publication/Widgets/WidgetRelations';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    publicationId: string;
    hasRelations?: boolean;
    onClose: () => void;
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

const RelationsDrawer: React.FC<IProps> = (props) => {
    const { onClose, publicationId, hasRelations } = props;

    if (hasRelations === false)
        return null;

    return (
        <WidgetDrawer onClose={onClose}>
            <WidgetRelations publicationId={publicationId} />
        </WidgetDrawer>
    );
};

export default RelationsDrawer;